export const VIMEO_ORIGIN = 'https://player.vimeo.com';
export const IFRAME_PLAYER_ID = 'vimeo-embed-player';

/** Chromeless: controls=0 skjuler more options m.m., api=1 for postMessage. player_id må være satt for at iframe skal sende events. */
export function getDefaultParams(): string {
  return `loop=0&background=0&autoplay=0&muted=0&controls=0&api=1&player_id=${IFRAME_PLAYER_ID}`;
}

export function buildEmbedUrl(videoId: string | undefined, src: string | undefined, params: string): string | null {
  if (src) return src;
  if (!videoId) return null;
  const suffix = params.includes('player_id=') ? '' : `&player_id=${IFRAME_PLAYER_ID}`;
  return `https://player.vimeo.com/video/${videoId}?${params}${suffix}`;
}

/** Avgjør start-lyd fra params (muted=0 betyr lyd på) */
export function isMutedFromParams(params: string): boolean {
  const match = params.match(/muted=(\d)/);
  return match ? match[1] === '1' : true;
}

export function sendPlayAndUnmute(win: Window): void {
  win.postMessage(JSON.stringify({ method: 'setVolume', value: 1 }), VIMEO_ORIGIN);
  win.postMessage(JSON.stringify({ method: 'play' }), VIMEO_ORIGIN);
}

export function sendSetVolume(win: Window | null | undefined, volume: number): void {
  if (!win) return;
  win.postMessage(JSON.stringify({ method: 'setVolume', value: volume }), VIMEO_ORIGIN);
}

export function subscribeToPlayerEvents(win: Window | null | undefined): void {
  if (!win) return;
  ['finish', 'ended', 'pause'].forEach((eventName) => {
    win.postMessage(JSON.stringify({ method: 'addEventListener', value: eventName }), VIMEO_ORIGIN);
  });
}

export function parseVimeoMessage(data: unknown): { event?: string; method?: string; value?: boolean } | null {
  if (data == null) return null;
  if (typeof data === 'string') {
    try {
      return JSON.parse(data) as { event?: string; method?: string; value?: boolean };
    } catch {
      return null;
    }
  }
  return data as { event?: string; method?: string; value?: boolean };
}

export interface PlayClickHandlerOptions {
  getWindow: () => Window | null | undefined;
  setShowPlayOverlay: (show: boolean) => void;
  setIsMuted: (muted: boolean) => void;
  pendingPlayRef: { current: boolean };
}

export function createPlayClickHandler(options: PlayClickHandlerOptions): () => void {
  const { getWindow, setShowPlayOverlay, setIsMuted, pendingPlayRef } = options;
  return () => {
    const win = getWindow();
    if (!win) return;
    setShowPlayOverlay(false);
    setIsMuted(false);
    pendingPlayRef.current = true;
    sendPlayAndUnmute(win);
  };
}
